module.exports = __webpack_public_path__ + "img/hash_eoshashcoins.b631a77.png";